var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"aha-radio",class:[
    ("aha-radio--" + _vm.size),
    {
      'aha-radio--disabled': _vm.disabled,
      'aha-radio--checked': _vm.checked,
      'custom-mr-2': _vm.hasMarginRight,
    } ]},[(_vm.checked)?_c('span',{staticClass:"aha-radio__core"}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }